import React from 'react';
import DropdownWrapper, { ExportedDropdownProps } from '../../../modules/common/DropdownWrapper';
import DropDownList, { DropDownListValueProps } from '../DropDownList';
import InternalTextDropDown from './TextDropDown';
import {
  TextDropDownProps,
  TextDropDownValueProps as InternalTextDropDownValueProps,
} from './types';

import styles from './TextDropDownOverride.module.scss';

export type { TextDropDownProps }; // MANUAL OVERRIDE

// MANUAL OVERRIDE
export type TextDropDownValueProps = ExportedDropdownProps<
InternalTextDropDownValueProps,
DropDownListValueProps
>;

// MANUAL OVERRIDE
const TextDropDown: React.FC<TextDropDownValueProps> = ({ id, toggleProps, menuProps, className }) => (
  <DropdownWrapper
    id={id}
    Toggle={InternalTextDropDown}
    Menu={DropDownList}
    toggleProps={toggleProps}
    menuProps={menuProps}
    className={`${className} ${styles.dropDownList}`}
  />
);

export default TextDropDown;
